module.exports = __webpack_public_path__ + "static/media/listView.b4e914fe.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/listView.svg
// module id = 6258
// module chunks = 0